import apiAction from '../apiActionCreator';

const type = 'SET_AUDIT_TRAIL';

const config = {
  url: '/agreement/audit-trail/step',
  actionType: type,
  sendFormat: 'json',
  method: 'POST',
};

export default apiAction(config);
